import { render, staticRenderFns } from "./StickyBottomActions.vue?vue&type=template&id=36925507&scoped=true&"
import script from "./StickyBottomActions.vue?vue&type=script&lang=js&"
export * from "./StickyBottomActions.vue?vue&type=script&lang=js&"
import style0 from "./StickyBottomActions.vue?vue&type=style&index=0&id=36925507&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36925507",
  null
  
)

export default component.exports